module.exports = __webpack_public_path__ + "static/media/close-circle.af49880b.svg";